import { render, staticRenderFns } from "./properties-block-iframe.vue?vue&type=template&id=64f94d38&scoped=true"
import script from "./properties-block-iframe.vue?vue&type=script&lang=js"
export * from "./properties-block-iframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f94d38",
  null
  
)

export default component.exports